import { deleteCookie } from '../cookies';
import { initSessionData } from '../session_data';

initSessionData();

function setCookie(key, value) {
  const d = new Date();
  d.setTime(d.getTime() + 90 * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString(),
    domain = 'testowaplatforma123.net';
  document.cookie = `${key}=${value};${expires};path=/;domain=${domain}`;
}

document.addEventListener('click', (e) => {
  if (e.target.type == 'submit' && e.target.closest('.js-form-login')) {
    setCookie('session_brand', BRAND_NAME);
    deleteCookie('session_token');
  }
});
